jQuery(($) => {

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser - Keydown Focus Class
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $("body").on("keydown", function () {
        if (!$(".keyboard-in-use")[0]) {
            $(this).addClass("keyboard-in-use");
        }
    });

    $("body").on("mousedown", function () {
        if ($(".keyboard-in-use")[0]) {
            $(this).removeClass("keyboard-in-use");
        }
    });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ SECTION_NAME
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $(window).on('load resize', function() {
        if (($('body').css('overflow', 'hidden') && !$('.o-header--open')[0]) || $(window).width() >= 1200) {
            $('body').removeAttr('style');
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Header
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $(window).on('load scroll', function () {
        var distance = $(window).scrollTop();

        if (distance > 35) {
            $('.o-header').addClass('o-header--sticky');
        } else {
            $('.o-header').removeClass('o-header--sticky');
        }
        if (distance > 25) {
            $('.o-header').addClass('o-header--mobile');
        } else {
            $('.o-header').removeClass('o-header--mobile');
        }
    });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Header
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var $header_toggle   = $('.o-header .js-mobile-toggle'),
        $header_nav_list = $('.o-header .m-page-nav__list');

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟MenuToggle
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $header_toggle.click(function () {
        if ($('.o-header--open')[0]) {
            $('body').removeAttr('style');
        } else {
            $('body').css('overflow', 'hidden');
        }

        $(this).toggleClass('a-hamburger--toggled');
        $('.o-header').toggleClass('o-header--open');
        $('.o-header__navigation-outer').toggleClass('o-header__navigation-outer--open');
    });


    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Accessibility
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    if ($header_toggle[0]) {
        // On Toggle Keydown
        $header_toggle.keydown(function (e) {

            if (e.key === 'Enter') {
                e.preventDefault();

                $('.o-header__wrapper').toggleClass('o-header__wrapper--open');

                if ($('.o-header__wrapper').hasClass('o-header__wrapper--open')) {
                    $header_nav_list.attr('aria-expanded', 'true');
                    $(this).attr('aria-pressed', 'true');
                    $(this).addClass('a-hamburger--toggled');
                    $('body').css('overflow', 'hidden');

                } else {
                    $header_nav_list.attr('aria-expanded', 'false');
                    $(this).attr('aria-pressed', 'false');
                    $(this).removeClass('a-hamburger--toggled');
                    $('body').removeAttr('style');
                }

                setTimeout(function () {
                    list.find("li:first-child a").focus();
                }, 0);
            }
        });
    }
});